import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import { RefObject, useCallback } from 'react';

export const useDropdown = (
	dropdown: RefObject<HTMLDivElement | null>,
	escapeKeyEnabled: boolean = true,
): [boolean | undefined, () => void] => {
	const [isOpen, setIsOpen] = useDetectOutsideClick(dropdown, false, escapeKeyEnabled);
	const toggleDropdown = useCallback(() => setIsOpen(!isOpen), [setIsOpen, isOpen]);

	return [isOpen, toggleDropdown];
};
